import { useEffect, useMemo, useState } from 'react';
import { Icon } from '../../../../../../base/components/Icon';
import { useAppDispatch, useAppSelector } from '../../../../../../base/hooks';
import { responsesActions } from '../../../redux/slices/responsesSlice';
import { __t } from '../../../../../../base/utils/t';
import { VacancyItemAll } from '../DesktopSelects/VacancySelect';

import './styles.scss';
import { useSearchParams } from 'react-router-dom';

interface Props {
    className?: string;
}

export const VacancySelectMobile = ({ className = '' }: Props) => {
    const dispatch = useAppDispatch();
    const {
        vacancySelectOptions,
        filters: { vacancyId },
    } = useAppSelector((state) => state.employerResponses);
    const [showSelectPopup, setShowSelectPopup] = useState(false);

    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (!vacancySelectOptions.length) {
            return;
        }
        const paramsVacancyId = searchParams.get('vacancy');
        if (paramsVacancyId) {
            dispatch(responsesActions.setFiltersVacancy(paramsVacancyId as unknown as number));
        }
    }, [searchParams, vacancySelectOptions]);

    useEffect(() => {
        if (showSelectPopup) {
            document.documentElement.setAttribute('DisableScroll', 'true');
            return;
        }
        document.documentElement.removeAttribute('DisableScroll');

        return () => {
            document.documentElement.removeAttribute('DisableScroll');
        };
    }, [showSelectPopup]);

    const handleChange = (vacancyId: number) => {
        dispatch(responsesActions.setFiltersVacancy(vacancyId));
        togglePopupVisibility();
    };

    const clearFilter = (event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
        dispatch(responsesActions.setFiltersVacancy(VacancyItemAll.id));
    };

    const togglePopupVisibility = () => {
        setShowSelectPopup(!showSelectPopup);
    };

    const renderValue = useMemo(() => {
        if (vacancyId === VacancyItemAll.id) {
            return VacancyItemAll.name;
        }

        return vacancySelectOptions.find((v) => v.id === vacancyId)?.name;
    }, [vacancyId]);

    const activeVacancies = vacancySelectOptions
        .filter((i) => i.isActive)
        .map(({ id, name }) => (
            <div
                className={`responses-filters-mobile-select-popup__select-item ${
                    id === vacancyId ? 'responses-filters-mobile-select-popup__select-item--selected' : ''
                }`}
                onClick={() => handleChange(id)}
                key={id}
            >
                <span className='responses-filters-mobile-select-popup__select-item-text' title={name}>
                    {name}
                </span>
                <span className='responses-filters-mobile-select-popup__select-item-additional-text'>
                    <span className='responses-filters-mobile-select-popup__select-item-additional-text-separator'>
                        ·
                    </span>
                    {__t('ID')}:{id}
                </span>
            </div>
        ));

    const closedVacancies = vacancySelectOptions
        .filter((i) => !i.isActive)
        .map(({ id, name }) => (
            <div
                className={`responses-filters-mobile-select-popup__select-item ${
                    id === vacancyId ? 'responses-filters-mobile-select-popup__select-item--selected' : ''
                }`}
                onClick={() => handleChange(id)}
                key={id}
            >
                <span className='responses-filters-mobile-select-popup__select-item-text' title={name}>
                    {name}
                </span>
                <span className='responses-filters-mobile-select-popup__select-item-additional-text'>
                    <span className='responses-filters-mobile-select-popup__select-item-additional-text-separator'>
                        ·
                    </span>
                    {__t('ID')}:{id}
                </span>
            </div>
        ));

    return (
        <>
            <div className={`responses-filters-mobile-select ${className}`} onClick={togglePopupVisibility}>
                {vacancyId !== VacancyItemAll.id && (
                    <div onClick={clearFilter} className='responses-filters-mobile-select__clear-filter-button'>
                        <Icon icon='xmark-regular' size='14px' className='responses-filters-mobile-select__icon' />
                    </div>
                )}
                <span className='responses-filters-mobile-select__display-value-text'>{renderValue}</span>
                <Icon icon='chevron-down-regular' size='14px' className='responses-filters-mobile-select__icon' />
            </div>

            {showSelectPopup && (
                <>
                    <div
                        className='responses-filters-mobile-select-popup__background'
                        onClick={togglePopupVisibility}
                    ></div>
                    <div className='responses-filters-mobile-select-popup' style={{ padding: '8px 4px 4px 4px' }}>
                        <div
                            onClick={togglePopupVisibility}
                            className='responses-filters-mobile-select-popup__close-button'
                        >
                            <Icon icon='xmark-regular' size='24px' color='white' />
                        </div>
                        <div className='responses-filters-mobile-select-popup__content'>
                            <div className='responses-filters-mobile-select-popup__subheader responses-filters-mobile-select-popup__subheader--highlighted'>
                                {__t('Відкриті вакансії')}
                            </div>

                            {activeVacancies}

                            <div className='responses-filters-mobile-select-popup__subheader'>
                                {__t('Закриті вакансії')}
                            </div>

                            {closedVacancies}
                        </div>
                    </div>
                </>
            )}
        </>
    );
};
